import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  GetGroupedContactInformation,
  GetManualStaffGroups,
  GetStaffInformation,
} from '../services/staff';
import { useAuth } from './auth';

const GroupsContext = createContext();
const GroupsProvider = ({ children }) => {
  const [groups, setGroups] = useState([]);
  const [staffGroupMemberships, setStaffGroupMemberships] = useState([]);
  const [staffGroups, setStaffGroups] = useState([]);
  const [menuGroups, setMenuGroups] = useState(false);
  const { identificationId, portal } = useAuth();
  useEffect(() => {
    loadGroupsData(true);
  }, [identificationId, portal]);

  const reloadGroups = async () => {
    await loadGroupsData(false);
  };

  const loadGroupsData = async (shouldSetMemberships = false) => {
    if (identificationId && portal) {
      const response = await GetStaffInformation({
        identificationId,
      });
      setGroups(response.staffGroups);

      if (shouldSetMemberships) {
        setStaffGroupMemberships(response.staffGroupMemberships);
      }

      let list = [];
      if (
        response.staffGroupMemberships &&
        Array.isArray(response.staffGroupMemberships)
      ) {
        list = response.staffGroupMemberships.map((group) =>
          response.staffGroups.find(
            (sgroup) => sgroup.GroupGuid === group.GroupGuid
          )
        );
      }

      const groupedInformation = await GetGroupedContactInformation();
      if (groupedInformation.GetGroupedContactInformation_V1Result) {
        groupedInformation.staffGroupList.forEach((group) => {
          if (!list.some((l) => l.GroupGuid === group.GroupGuid)) {
            list.push({
              ...group,
            });
          }
        });
      }
      setStaffGroups(list);
    }
  };
  return (
    <GroupsContext.Provider
      value={{
        groups,
        staffGroups,
        menuGroups,
        setMenuGroups,
        reloadGroups,
        staffGroupMemberships,
        setStaffGroupMemberships,
        loadGroupsData,
      }}
    >
      {children}
    </GroupsContext.Provider>
  );
};

function useGroups() {
  const context = useContext(GroupsContext);
  if (!context) {
    throw new Error('useGroups must be used within a AppProvider');
  }
  return context;
}
export { GroupsProvider, GroupsContext, useGroups };
